import React from 'react';
import { Palette } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatures from '../../components/services/sections/ServiceFeatures';
import ServiceBenefits from '../../components/services/sections/ServiceBenefits';
import ServiceSteps from '../../components/services/sections/ServiceSteps';
import { canvaFeatures } from '../../data/services/canvaPro';
import { colors } from '../../styles/theme';

const benefits = [
  {
    value: "100%",
    label: "Free for students"
  },
  {
    value: "Unlimited",
    label: "Access to all features"
  },
  {
    value: "For premium members",
    label: "Priority support included"
  }
];

const steps = [
  {
    title: "Sign up on EUROPEAN STUDENT",
    description: "Create your student account in just a few clicks"
  },
  {
    title: "Verify your student status",
    description: "Upload your student card or enrollment certificate"
  },
  {
    title: "Activate your Canva Pro account",
    description: "Receive your credentials by email in just a few seconds"
  }
];

const CanvaProPage = () => {
  const handleActivate = () => {
    window.location.href = 'https://my.europeanstudent.org/store/canva';
  };

  return (
    <div>
      <ServiceHeader
        title="Canva Pro"
        description="Unleash your creativity with full access to Canva Pro. Create professional designs for your academic and personal projects."
        icon={<Palette className="w-8 h-8 text-white" />}
        color={colors.secondary}
        imageUrl="https://static-cse.canva.com/blob/1825140/voeux-professionnels-originaux.jpg"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <ServiceFeatures
          title="Premium Features"
          features={canvaFeatures}
          color={colors.secondary}
        />

        <ServiceBenefits
          title="Student Benefits"
          benefits={benefits}
          color={colors.secondary}
        />

        <ServiceSteps
          title="How to get started"
          steps={steps}
          color={colors.secondary}
          ctaText="Activate my Canva Pro account"
          onCtaClick={handleActivate}
        />
      </div>
    </div>
  );
};

export default CanvaProPage;